import React from 'react';
import { useArrayFieldApi } from '../../hooks/useArrayFieldApi.js';

var AddButton = function AddButton(_ref) {
  var text = _ref.text;
  var _useArrayFieldApi = useArrayFieldApi(),
    add = _useArrayFieldApi.add;
  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      add();
    },
    type: "button"
  }, text ? text : 'Add');
};

export { AddButton };
